export const UPDATE_VALIDATION_SCHEMA = 'UPDATE_VALIDATION_SCHEMA';
